import { mainService } from '@/utils/request'
// 获取认证信息
export function getPersonRealnameAuth (data) {
  return mainService({
    url: 'app/person/get_real_name',
    method: 'post',
    data: data
  })
}
// 实名认证
export function personRealnameAuthSure (data) {
  return mainService({
    url: 'app/person/real_name',
    method: 'post',
    data: data
  })
}

// 获取短信验证码
export function getRealNamePhoneCode (data) {
  return mainService({
    url: 'app2/user/getCode',
    method: 'post',
    data: data
  })
}
